var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66683 3.66667L7.92314 2.17928C7.7091 1.7512 7.60207 1.53715 7.44241 1.38078C7.30122 1.24249 7.13105 1.13732 6.94421 1.07287C6.73294 1 6.49363 1 6.01502 1H3.46683C2.72009 1 2.34672 1 2.06151 1.14532C1.81063 1.27316 1.60665 1.47713 1.47882 1.72801C1.3335 2.01323 1.3335 2.3866 1.3335 3.13333V3.66667M1.3335 3.66667H11.4668C12.5869 3.66667 13.147 3.66667 13.5748 3.88465C13.9511 4.0764 14.2571 4.38236 14.4488 4.75869C14.6668 5.18651 14.6668 5.74656 14.6668 6.86667V9.8C14.6668 10.9201 14.6668 11.4802 14.4488 11.908C14.2571 12.2843 13.9511 12.5903 13.5748 12.782C13.147 13 12.5869 13 11.4668 13H4.5335C3.41339 13 2.85334 13 2.42552 12.782C2.04919 12.5903 1.74323 12.2843 1.55148 11.908C1.3335 11.4802 1.3335 10.9201 1.3335 9.8V3.66667Z",
    stroke: "#EA4903",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.54ab8a99f950fa46f781d81079617393.svg";
export { ForwardRef as ReactComponent };